console.log('Index page loaded');